// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { z } from 'zod';

const invoiceDetailResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export async function getInvoiceByKey(invoiceKey: string) {
  const url = `/v1/invoice/${invoiceKey}`;
  const response = await api.get(url);
  const result = await parseResponse(
    invoiceDetailResponseSchema,
    response.data,
    {
      schemaName: 'InvoiceDetail',
      endpoint: url,
    }
  );
  return result.data;
}
